import moment from "moment";
import { AssetVersionModel } from "lib/types/assets/AssetVersionModel";

export function getAssetVersionFromResponse(r): AssetVersionModel {
  return {
    id: r.id,
    assetId: r.assetId,
    assetIngressId: r.assetIngressId,
    prefix: r.prefix,
    major: r.major,
    minor: r.minor,
    contentUri: r.contentUri ?? r.vectorContentUri,
    vectorContentUri: r.vectorContentUri,
    propertiesReference: r.propertiesReference,
    createdOn: moment(r.createdOn),
    createdBy: r.createdBy,
    sizeBytes: r.sizeBytes,
    longitude: r.longitude,
    latitude: r.latitude,
    isFarAwayFromProject: r.isFarAwayFromProject,
    isFarAwayFromProjectAndUnresolved:
      r.isFarAwayFromProject && !r.isMarkedCorrectlyPositioned,
    isMarkedCorrectlyPositioned: r.isMarkedCorrectlyPositioned,
    canPromote: r.canPromote,
    canDelete: r.canDelete,
  };
}
